import { getCookie, removeCookie } from "./cookies";

const token = (function () {
	let token: string | null = null;

	return {
		setToken: (value: string | null) => {
			token = value;
		},

		getToken: (): string | null => {
			return token;
		},
	};
})();

/**
 * @deprecated
 * In the future the access token will not be found anymore in a cookie but is stored in memory.
 * We keep it for now to make sure it is removed properly
 */
export const ACCESS_TOKEN_COOKIE_NAME = "access_token";
/**
 * @deprecated
 * When the refresh token is set to a http cookie, we can not delete it anymore by script
 */
export const REFRESH_TOKEN_COOKIE_NAME = "refresh_token";

export function removeTokens(): void {
	token.setToken(null);
	removeCookie(ACCESS_TOKEN_COOKIE_NAME); //todo <-- this can be removed in the future as the access token is not stored in a cookie anmore
	removeCookie(REFRESH_TOKEN_COOKIE_NAME);
}

export function setAccessToken(accessToken: string) {
	token.setToken(accessToken);
}

export function hasAuthCookies(): boolean {
	return true;
}

export function getAccessToken(): string | null {
	return token.getToken();
}

/**
 * @deprecated
 * In future releases the refresh token will be sent as a cookie set from the http response. Hence the refresh token does
 * not need to be sent along with the refresh request
 */
export function getRefreshToken(): string | null {
	return getCookie(REFRESH_TOKEN_COOKIE_NAME);
}

export function removeNewAppForceCookie() {
	removeCookie("force_new_player_fe");
}
